var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.toggleSidebar}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }